import React from 'react';
import ReactDOM from 'react-dom/client';
import ToadApp from './ToadApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><ToadApp /></React.StrictMode>);
